<template>
  <div>
    <div v-if="Object.keys(rider).length != 0 && rider.constructor === Object">
      <v-toolbar dense>
        <v-btn
          icon
          style="position: absolute; top: 2px; left: 10px"
          @click="$router.go(-1)"
        >
          <v-icon>arrow_back</v-icon>
        </v-btn>
        <v-spacer />
        <h2>General Information</h2>
        <v-spacer />
      </v-toolbar>
      <v-card>
        <v-card-text>
          <v-layout row wrap>
            <v-flex md6 sm12 class="px-2">
              <v-card style="min-height: 400px">
                <v-toolbar dense flat>
                  <v-spacer />
                  <h2 class="text-xs-center">Rider Profiles</h2>
                  <v-spacer />
                </v-toolbar>
                <v-card-text>
                  <v-layout row wrap>
                    <v-flex xs6 class="pr-2">
                      <v-select
                        :disabled="
                          isApprove == true
                            ? isEditApproveRiderList
                            : isEditRiderList
                        "
                        v-model="rider.user_info.ri_provinces_id"
                        :items="provice"
                        item-text="province_name_th"
                        item-value="id"
                        label="Province"
                        hide-details
                        @change="
                          getDistrictList();
                          rider.user_info.ri_district_id = [];
                        "
                      ></v-select>
                    </v-flex>
                    <v-flex xs6 class="pl-2">
                      <v-autocomplete
                        multiple
                        :disabled="
                          isApprove == true
                            ? isEditApproveRiderList
                            : isEditRiderList
                        "
                        v-model="rider.user_info.ri_district_id"
                        :items="districtList"
                        item-text="district_name_th"
                        item-value="district_id"
                        label="Area"
                        hide-details
                        :loading="isLoadingDistrict"
                      ></v-autocomplete>
                    </v-flex>
                    <!-- <v-flex class="ml-2">
                      <v-select
                      :disabled="(isApprove == true ? isEditApproveRiderList  : isEditRiderList ) "
                        :items="branch_items"
                        label="Branch"
                        persistent-hint
                        return-object
                        single-line
                      ></v-select>
                    </v-flex>-->
                  </v-layout>
                  <v-layout row>
                    <v-flex xs12>
                      <v-text-field
                        :disabled="
                          isApprove == true
                            ? isEditApproveRiderList
                            : isEditRiderList
                        "
                        label="Full Name"
                        v-model="rider.users.users_name"
                        hide-details
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex class="mr-2">
                      <v-text-field
                        label="First Name"
                        v-model="rider.users.users_first_name"
                        hide-details
                        :disabled="
                          isApprove == true
                            ? isEditApproveRiderList
                            : isEditRiderList
                        "
                      ></v-text-field>
                    </v-flex>
                    <v-flex class="ml-2">
                      <v-text-field
                        :disabled="
                          isApprove == true
                            ? isEditApproveRiderList
                            : isEditRiderList
                        "
                        label="Last Name"
                        v-model="rider.users.users_last_name"
                        hide-details
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex class="mr-2">
                      <v-text-field
                        :disabled="
                          isApprove == true
                            ? isEditApproveRiderList
                            : isEditRiderList
                        "
                        label="Email"
                        v-model="rider.users.users_email"
                      ></v-text-field>
                    </v-flex>
                    <v-flex class="ml-2">
                      <v-text-field
                        :disabled="
                          isApprove == true
                            ? isEditApproveRiderList
                            : isEditRiderList
                        "
                        label="Tel."
                        v-model="rider.users.users_phone"
                        placeholder="0812345678"
                        mask="##########"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap align-center>
                    <v-flex
                      xs6
                      class="pr-2 text-xs-center"
                      style="position: relative"
                    >
                      <v-img
                        v-if="rider_profile_img"
                        :src="rider_profile_img"
                        aspect-ratio="1"
                        contain
                        height="176"
                      ></v-img>
                      <a
                        v-if="!rider_profile_img"
                        :href="rider.user_info_im.ri_profile_img"
                        target="_blank"
                        style="text-decoration: none"
                      >
                        <v-img
                          :src="rider.user_info_im.ri_profile_img"
                          height="176"
                        ></v-img>
                      </a>
                      <v-btn
                        @click="$refs.onUploadProfileIMG.click()"
                        :disabled="
                          isApprove == true
                            ? isEditApproveRiderList
                            : isEditRiderList
                        "
                        >edit image</v-btn
                      >
                      <v-btn
                        @click="rider_profile_img = null"
                        v-if="rider_profile_img"
                        style="position: absolute; top: -12px; right: 0"
                        icon
                        :disabled="
                          isApprove == true
                            ? isEditApproveRiderList
                            : isEditRiderList
                        "
                      >
                        <v-icon color="red">cancel</v-icon>
                      </v-btn>
                      <input
                        type="file"
                        @change="OnImageSelected($event, 'profile')"
                        ref="onUploadProfileIMG"
                        style="display: none"
                      />
                    </v-flex>
                    <v-flex xs6 class="pl-2">
                      <v-select
                        :disabled="
                          isApprove == true
                            ? isEditApproveRiderList
                            : isEditRiderList
                        "
                        v-model="rider.users.user_status"
                        :items="items"
                        item-text="name"
                        item-value="value"
                        label="User status"
                        persistent-hint
                        single-line
                        v-if="
                          isApprove == false && rider.users.user_status != 4
                        "
                      ></v-select>
                      <v-btn
                        @click="dialog = true"
                        :disabled="
                          isApprove == true
                            ? isEditApproveRiderList
                            : isEditRiderList
                        "
                      >
                        <v-icon>vpn_key</v-icon>&nbsp; Change password
                      </v-btn>
                    </v-flex>
                    <v-dialog v-model="dialog" persistent max-width="350">
                      <v-card>
                        <v-toolbar dark dense>
                          <v-spacer />
                          <v-toolbar-title>Change password</v-toolbar-title>
                          <v-btn
                            icon
                            absolute
                            style="top: 0px; right: 0"
                            :disabled="
                              isApprove == true
                                ? isEditApproveRiderList
                                : isEditRiderList
                            "
                            @click="closeRepassword()"
                          >
                            <v-icon>close</v-icon>
                          </v-btn>
                          <v-spacer />
                        </v-toolbar>
                        <v-card-text>
                          <v-form v-model="valid" ref="repasswordForm">
                            <v-text-field
                              :disabled="
                                isApprove == true
                                  ? isEditApproveRiderList
                                  : isEditRiderList
                              "
                              v-model="password1"
                              :append-icon="
                                show2 ? 'visibility_off' : 'visibility'
                              "
                              :rules="[rules.min, rules.required]"
                              :type="show2 ? 'text' : 'password'"
                              name="input-1"
                              label="New password"
                              hint="At least 8 characters"
                              color="black"
                              class="input-group--focused"
                              @click:append="show2 = !show2"
                              hide-details
                            ></v-text-field>
                            <v-text-field
                              :disabled="
                                isApprove == true
                                  ? isEditApproveRiderList
                                  : isEditRiderList
                              "
                              v-model="password2"
                              :append-icon="
                                show3 ? 'visibility_off' : 'visibility'
                              "
                              :rules="[rules.required, rules.min]"
                              :type="show3 ? 'text' : 'password'"
                              name="input-2"
                              label="Confirm new password"
                              hint="At least 8 characters"
                              color="black"
                              class="input-group--focused"
                              @click:append="show3 = !show3"
                              hide-details
                            ></v-text-field>
                          </v-form>
                        </v-card-text>
                        <v-divider />
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="red"
                            flat
                            @click="closeRepassword()"
                            :disabled="repasswording"
                            >Cancel</v-btn
                          >
                          <v-btn
                            color="green darken-1"
                            flat
                            @click="repasswordRider()"
                            :disabled="repasswording"
                            :loading="repasswording"
                            >Save</v-btn
                          >
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>

            <v-flex md6 sm12 class="px-2">
              <v-card style="min-height: 400px">
                <v-toolbar dense flat>
                  <v-spacer />
                  <h2 class="text-xs-center">Vehicle</h2>
                  <v-spacer />
                </v-toolbar>
                <v-card-text>
                  <v-select
                    :disabled="
                      isApprove == true
                        ? isEditApproveRiderList
                        : isEditRiderList
                    "
                    v-model="rider.user_info.ri_vehicle_model"
                    :items="vehicle"
                    item-text="vt_name"
                    item-value="id"
                    label="Vehicle Type"
                    hide-details
                  ></v-select>
                  <!-- <v-checkbox
                    v-model="rider.user_info.ri_motor_box"
                    label="Does the rider have a box?"
                    color="green"
                  ></v-checkbox>-->
                  <v-layout row>
                    <v-flex class="mr-2">
                      <v-text-field
                        :disabled="
                          isApprove == true
                            ? isEditApproveRiderList
                            : isEditRiderList
                        "
                        v-model="rider.user_info.ri_vehicle_brand"
                        label="Brand"
                        hide-details
                      ></v-text-field>
                    </v-flex>
                    <v-flex class="ml-2">
                      <v-text-field
                        :disabled="
                          isApprove == true
                            ? isEditApproveRiderList
                            : isEditRiderList
                        "
                        label="Model"
                        hide-details
                        v-model="rider.user_info.ri_vehicle_model_name"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex class="mr-2">
                      <v-text-field
                        :disabled="
                          isApprove == true
                            ? isEditApproveRiderList
                            : isEditRiderList
                        "
                        v-model="rider.user_info.ri_vehicle_model_year"
                        label="Years"
                        hide-details
                      ></v-text-field>
                    </v-flex>
                    <v-flex class="ml-2">
                      <v-text-field
                        :disabled="
                          isApprove == true
                            ? isEditApproveRiderList
                            : isEditRiderList
                        "
                        label="Plate number"
                        v-model="rider.user_info.ri_plate_number"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap class="text-xs-center">
                    <v-flex xs12 style="position: relative">
                      <v-img
                        v-if="rider_vehicle_img"
                        :src="rider_vehicle_img"
                        aspect-ratio="1"
                        contain
                        height="176"
                      ></v-img>
                      <a
                        v-if="!rider_vehicle_img"
                        :href="rider.user_info_im.ri_plate_number_img"
                        target="_blank"
                        style="text-decoration: none"
                      >
                        <v-img
                          :src="rider.user_info_im.ri_plate_number_img"
                          aspect-ratio="1"
                          contain
                          height="176"
                        ></v-img>
                      </a>
                      <v-btn
                        @click="$refs.onUploadVehicleIMG.click()"
                        :disabled="
                          isApprove == true
                            ? isEditApproveRiderList
                            : isEditRiderList
                        "
                        >edit image</v-btn
                      >
                      <v-btn
                        icon
                        @click="rider_vehicle_img = null"
                        v-if="rider_vehicle_img"
                        style="position: absolute; top: -12px; right: 0"
                        :disabled="
                          isApprove == true
                            ? isEditApproveRiderList
                            : isEditRiderList
                        "
                      >
                        <v-icon color="red">cancel</v-icon>
                      </v-btn>
                      <input
                        type="file"
                        @change="OnImageSelected($event, 'vehicle')"
                        ref="onUploadVehicleIMG"
                        style="display: none"
                      />
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
          <v-layout rpw wrap class="mt-2">
            <v-flex sm12 md6 class="px-4">
              <v-layout row wrap align-center justify-center class="my-2">
                <v-flex
                  xs6
                  class="pr-2 text-xs-center"
                  style="position: relative"
                >
                  <v-img
                    v-if="rider_vehicle_number_img"
                    :src="rider_vehicle_number_img"
                    aspect-ratio="1"
                    contain
                    height="176"
                  ></v-img>
                  <a
                    v-if="!rider_vehicle_number_img"
                    :href="rider.user_info_im.ri_plate_number_img"
                    target="_blank"
                    style="text-decoration: none"
                  >
                    <v-img
                      :src="rider.user_info_im.ri_plate_number_img"
                      aspect-ratio="1"
                      contain
                      height="176"
                    ></v-img>
                  </a>
                  <v-btn
                    :disabled="
                      isApprove == true
                        ? isEditApproveRiderList
                        : isEditRiderList
                    "
                    @click="$refs.onUploadVehicleNumberIMG.click()"
                    >edit image</v-btn
                  >
                  <v-btn
                    icon
                    :disabled="
                      isApprove == true
                        ? isEditApproveRiderList
                        : isEditRiderList
                    "
                    @click="rider_vehicle_number_img = null"
                    v-if="rider_vehicle_number_img"
                    style="position: absolute; top: 0px; right: 0"
                  >
                    <v-icon color="red">cancel</v-icon>
                  </v-btn>
                  <input
                    type="file"
                    @change="OnImageSelected($event, 'vehicle_number')"
                    ref="onUploadVehicleNumberIMG"
                    style="display: none"
                  />
                </v-flex>
                <v-flex xs6 class="pa-2">
                  <v-text-field
                    :disabled="
                      isApprove == true
                        ? isEditApproveRiderList
                        : isEditRiderList
                    "
                    v-model="rider.user_info.ri_plate_number"
                    label="ป้ายทะเบียนรถ"
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout row wrap align-center class="my-2">
                <v-flex
                  xs6
                  class="pr-2 text-xs-center"
                  style="position: relative"
                >
                  <v-img
                    v-if="rider_driving_lc_img"
                    :src="rider_driving_lc_img"
                    aspect-ratio="1"
                    contain
                    height="176"
                  ></v-img>
                  <a
                    v-if="!rider_driving_lc_img"
                    :href="rider.user_info_im.ri_driving_license_front_img"
                    target="_blank"
                    style="text-decoration: none"
                  >
                    <v-img
                      :src="rider.user_info_im.ri_driving_license_front_img"
                      aspect-ratio="1"
                      contain
                      height="176"
                    ></v-img>
                  </a>
                  <v-btn
                    :disabled="
                      isApprove == true
                        ? isEditApproveRiderList
                        : isEditRiderList
                    "
                    @click="$refs.onUploadDrivingLCIMG.click()"
                    >edit image</v-btn
                  >
                  <v-btn
                    icon
                    :disabled="
                      isApprove == true
                        ? isEditApproveRiderList
                        : isEditRiderList
                    "
                    @click="rider_driving_lc_img = null"
                    v-if="rider_driving_lc_img"
                    style="position: absolute; top: -12px; right: 0"
                  >
                    <v-icon color="red">cancel</v-icon>
                  </v-btn>
                  <input
                    type="file"
                    @change="OnImageSelected($event, 'driving_lc')"
                    ref="onUploadDrivingLCIMG"
                    style="display: none"
                  />
                </v-flex>
                <v-flex xs6 class="pa-2">
                  <v-text-field
                    :disabled="
                      isApprove == true
                        ? isEditApproveRiderList
                        : isEditRiderList
                    "
                    label="เลขที่ใบขับขี่"
                    mask="########"
                    v-model="rider.user_info.ri_drivg_licent_no"
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout row wrap align-center class="my-2">
                <v-flex
                  xs6
                  class="pr-2 text-xs-center"
                  style="position: relative"
                >
                  <v-img
                    v-if="rider_id_card_img"
                    :src="rider_id_card_img"
                    aspect-ratio="1"
                    contain
                    height="176"
                  ></v-img>
                  <a
                    v-if="!rider_id_card_img"
                    :href="rider.user_info_im.ri_id_card_img"
                    target="_blank"
                    style="text-decoration: none"
                  >
                    <v-img
                      :src="rider.user_info_im.ri_id_card_img"
                      aspect-ratio="1"
                      contain
                      height="176"
                    ></v-img>
                  </a>
                  <v-btn
                    :disabled="
                      isApprove == true
                        ? isEditApproveRiderList
                        : isEditRiderList
                    "
                    @click="$refs.onUploadIDCardIMG.click()"
                    >edit image</v-btn
                  >
                  <v-btn
                    icon
                    :disabled="
                      isApprove == true
                        ? isEditApproveRiderList
                        : isEditRiderList
                    "
                    @click="rider_id_card_img = null"
                    v-if="rider_id_card_img"
                    style="position: absolute; top: -12px; right: 0"
                  >
                    <v-icon color="red">cancel</v-icon>
                  </v-btn>
                  <input
                    type="file"
                    @change="OnImageSelected($event, 'id_card')"
                    ref="onUploadIDCardIMG"
                    style="display: none"
                  />
                </v-flex>
                <v-flex xs6 class="pa-2">
                  <v-text-field
                    :disabled="
                      isApprove == true
                        ? isEditApproveRiderList
                        : isEditRiderList
                    "
                    label="เลขที่บัตรประชาชน"
                    mask="#-####-#####-##-#"
                    v-model="rider.user_info.ri_id_card_no"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex sm12 md6>
              <v-layout row wrap align-center class="my-2">
                <v-flex
                  xs6
                  class="pr-2 text-xs-center"
                  style="position: relative"
                >
                  <v-img
                    v-if="rider_registerbook_img"
                    :src="rider_registerbook_img"
                    aspect-ratio="1"
                    contain
                    height="176"
                  ></v-img>
                  <a
                    v-if="!rider_registerbook_img"
                    :href="rider.user_info_im.ri_registerbook_img"
                    target="_blank"
                    style="text-decoration: none"
                  >
                    <v-img
                      :src="rider.user_info_im.ri_registerbook_img"
                      aspect-ratio="1"
                      contain
                      height="176"
                    ></v-img>
                  </a>
                  <v-btn
                    :disabled="
                      isApprove == true
                        ? isEditApproveRiderList
                        : isEditRiderList
                    "
                    @click="$refs.onUploadRegisBookIMG.click()"
                    >edit image</v-btn
                  >
                  <v-btn
                    icon
                    :disabled="
                      isApprove == true
                        ? isEditApproveRiderList
                        : isEditRiderList
                    "
                    @click="rider_registerbook_img = null"
                    v-if="rider_registerbook_img"
                    style="position: absolute; top: -12px; right: 0"
                  >
                    <v-icon color="red">cancel</v-icon>
                  </v-btn>
                  <input
                    type="file"
                    @change="OnImageSelected($event, 'registerbook_img')"
                    ref="onUploadRegisBookIMG"
                    style="display: none"
                  />
                </v-flex>
                <v-flex xs6 class="pa-2">
                  <v-textarea
                    :disabled="
                      isApprove == true
                        ? isEditApproveRiderList
                        : isEditRiderList
                    "
                    label="ข้อมูลคู่มือทะเบียนรถ"
                    rows="3"
                    v-model="rider.user_info.ri_registerbook"
                  ></v-textarea>
                </v-flex>
              </v-layout>

              <v-layout row wrap align-center class="my-2">
                <v-flex
                  xs6
                  class="pr-2 text-xs-center"
                  style="position: relative"
                >
                  <v-img
                    v-if="rider_phorabo_img"
                    :src="rider_phorabo_img"
                    aspect-ratio="1"
                    contain
                    height="176"
                  ></v-img>
                  <a
                    v-if="!rider_phorabo_img"
                    :href="rider.user_info_im.ri_phorabo_img"
                    target="_blank"
                    style="text-decoration: none"
                  >
                    <v-img
                      :src="rider.user_info_im.ri_phorabo_img"
                      aspect-ratio="1"
                      contain
                      height="176"
                    ></v-img>
                  </a>
                  <v-btn
                    :disabled="
                      isApprove == true
                        ? isEditApproveRiderList
                        : isEditRiderList
                    "
                    @click="$refs.onUploadPhoraboIMG.click()"
                    >edit image</v-btn
                  >
                  <v-btn
                    icon
                    :disabled="
                      isApprove == true
                        ? isEditApproveRiderList
                        : isEditRiderList
                    "
                    @click="rider_phorabo_img = null"
                    v-if="rider_phorabo_img"
                    style="position: absolute; top: -12px; right: 0"
                  >
                    <v-icon color="red">cancel</v-icon>
                  </v-btn>
                  <input
                    type="file"
                    @change="OnImageSelected($event, 'phorabo_img')"
                    ref="onUploadPhoraboIMG"
                    style="display: none"
                  />
                </v-flex>
                <v-flex xs6 class="pa-2">
                  <v-textarea
                    :disabled="
                      isApprove == true
                        ? isEditApproveRiderList
                        : isEditRiderList
                    "
                    label="ข้อมูลพรบ."
                    rows="3"
                  ></v-textarea>
                </v-flex>
              </v-layout>

              <v-layout row wrap align-center class="my-2">
                <v-flex
                  xs6
                  class="pr-2 text-xs-center"
                  style="position: relative"
                >
                  <v-img
                    v-if="rider_book_bank_img"
                    :src="rider_book_bank_img"
                    aspect-ratio="1"
                    contain
                    height="176"
                  ></v-img>
                  <a
                    v-if="!rider_book_bank_img"
                    :href="rider.user_info_im.ri_book_bank_img"
                    target="_blank"
                    style="text-decoration: none"
                  >
                    <v-img
                      :src="rider.user_info_im.ri_book_bank_img"
                      aspect-ratio="1"
                      contain
                      height="176"
                    ></v-img>
                  </a>
                  <v-btn
                    :disabled="
                      isApprove == true
                        ? isEditApproveRiderList
                        : isEditRiderList
                    "
                    @click="$refs.onUploadBookBankIMG.click()"
                    >edit image</v-btn
                  >
                  <v-btn
                    icon
                    :disabled="
                      isApprove == true
                        ? isEditApproveRiderList
                        : isEditRiderList
                    "
                    @click="rider_book_bank_img = null"
                    v-if="rider_book_bank_img"
                    style="position: absolute; top: -12px; right: 0"
                  >
                    <v-icon color="red">cancel</v-icon>
                  </v-btn>
                  <input
                    type="file"
                    @change="OnImageSelected($event, 'book_bank_img')"
                    ref="onUploadBookBankIMG"
                    style="display: none"
                  />
                </v-flex>
                <v-flex xs6 class="pa-2">
                  <v-form v-model="valid" ref="form">
                    <v-flex xs12>
                      <v-text-field
                        :disabled="
                          isApprove == true
                            ? isEditApproveRiderList
                            : isEditRiderList
                        "
                        v-model="rider.user_info.ri_bookbank_no"
                        label="เลขที่บัญชี"
                        counter="25"
                        mask="#########################"
                        :rules="
                          rider.user_info.ri_bookbank_no
                            ? [rules.required, rules.max]
                            : [rules.required]
                        "
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-select
                        :disabled="
                          isApprove == true
                            ? isEditApproveRiderList
                            : isEditRiderList
                        "
                        v-model="rider.user_info.ri_bookbank_brand"
                        :items="thai_bank"
                        item-text="thbk_name_th"
                        item-value="id"
                        label="บัญชีธนาคาร"
                        hide-details
                        :rules="[rules.required]"
                      ></v-select>
                    </v-flex>
                    <v-text-field
                      :disabled="
                        isApprove == true
                          ? isEditApproveRiderList
                          : isEditRiderList
                      "
                      v-model="rider.user_info.ri_bookbank_name"
                      label="ชื่อบัญชี"
                      :rules="[rules.required]"
                    ></v-text-field>
                  </v-form>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            :disabled="
              isApprove == true ? isEditApproveRiderList : isEditRiderList
            "
            @click="rejectRider"
            flat
            color="red"
            v-if="isApprove == true"
            >Reject</v-btn
          >
          <v-btn
            @click="updateData"
            :disabled="
              !approve_btn ||
              (isApprove == true ? isEditApproveRiderList : isEditRiderList)
            "
            :round="!isApprove"
            :block="!isApprove"
            :color="isApprove === true ? 'green' : 'primary'"
            class="black--text"
            >{{ isApprove === true ? "Approve" : "update data" }}</v-btn
          >
          <v-spacer />
        </v-card-actions>
      </v-card>
      <div></div>
    </div>
    <div v-else class="text-xs-center">
      <v-progress-circular
        :size="30"
        color="primary"
        indeterminate
      ></v-progress-circular
      >Loading data ...
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
export default {
  props: {
    rider: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data: () => ({
    districtList: [],
    isLoadingDistrict: false,
    isApprove: false,
    rider_book_bank_img: null,
    rider_phorabo_img: null,
    rider_registerbook_img: null,
    rider_id_card_img: null,
    rider_driving_lc_img: null,
    rider_vehicle_number_img: null,
    rider_vehicle_img: null,
    rider_profile_img: null,
    repasswording: false,
    valid: true,
    updating: false,
    rejecting: false,
    approve_btn_disable: false,
    items: [
      { name: "Pending", value: "2" },
      { name: "Active", value: "1" },
      { name: "Inactive", value: "3" },
    ],
    // branch_items: ["สาขากะทู้", "สาขาฉลอง"],
    // checkbox: true,
    dialog: false,
    show2: false,
    show3: false,
    password1: "",
    password2: "",
    rules: {
      required: (value) => !!value || "Required.",
      min: (v) => v.length >= 8 || "Minimum length is 8 characters.",
      max: (v) => v.length <= 25 || "Minimum length is 25 characters.",
    },
  }),
  mounted() {
    if (this.$route.params.isapprove == "isapprove") {
      this.isApprove = true;
    }
  },
  async created() {
    await this.$store.dispatch(
      "fetchRiderListBack/getRiderDetails",
      this.$route.params.id
    );
    this.$store.dispatch("fetchDefaultRider/getProvice"),
      this.getDistrictList(),
      this.$store.dispatch("fetchDefaultRider/getVehicleType"),
      this.$store.dispatch("fetchDefaultRider/getThaiBank");
  },
  computed: {
    ...mapState({
      permission: (state) => state.permission,
      provice: (state) => state.fetchDefaultRider.provice,
      vehicle: (state) => state.fetchDefaultRider.vehicle_type,
      thai_bank: (state) => state.fetchDefaultRider.thai_bank,
    }),
    isEditRiderList() {
      if (!this.permission.rider.rider_list.rider_user) {
        return true;
      }
      return this.permission.rider.rider_list.rider_user == 1 ? true : false;
    },
    isEditApproveRiderList() {
      if (!this.permission.rider.rider_list.rider_approve) {
        return true;
      }
      return this.permission.rider.rider_list.rider_approve == 1 ? true : false;
    },
    approve_btn() {
      if (
        this.rider.user_info.ri_bookbank_no != null &&
        this.rider.user_info.ri_bookbank_brand != null &&
        this.rider.user_info.ri_bookbank_name != null
      ) {
        this.approve_btn_disable = true;
      }
      return this.approve_btn_disable;
    },
  },
  methods: {
    async getDistrictList() {
      this.isLoadingDistrict = true;
      this.districtList = await this.$store.dispatch(
        "fetchProvinceBack/getDistrictCore",
        this.rider.user_info.ri_provinces_id
      );
      this.isLoadingDistrict = false;
    },
    OnImageSelected(event, img_type) {
      let file = event.target.files[0];
      this.image_name = file.name;
      let reader = new FileReader();
      reader.addEventListener("load", () => {
        if (img_type == "profile") {
          this.rider_profile_img = reader.result;
        } else if (img_type == "vehicle") {
          this.rider_vehicle_img = reader.result;
        } else if (img_type == "vehicle_number") {
          this.rider_vehicle_number_img = reader.result;
        } else if (img_type == "driving_lc") {
          this.rider_driving_lc_img = reader.result;
        } else if (img_type == "id_card") {
          this.rider_id_card_img = reader.result;
        } else if (img_type == "registerbook_img") {
          this.rider_registerbook_img = reader.result;
        } else if (img_type == "phorabo_img") {
          this.rider_phorabo_img = reader.result;
        } else if (img_type == "book_bank_img") {
          this.rider_book_bank_img = reader.result;
        }
      });
      reader.readAsDataURL(file);
      event.target.value = "";
    },
    closeRepassword() {
      this.password1 = "";
      this.password2 = "";
      this.dialog = false;
    },
    async repasswordRider() {
      if (this.$refs.repasswordForm.validate()) {
        if (this.password1 == this.password2) {
          this.repasswording = true;
          let check = await this.$store.dispatch(
            "fetchRiderListBack/repassword",
            {
              rider_id: this.rider.users.id,
              password: this.password2,
            }
          );
          this.repasswording = false;
          if (check != 3) {
            this.closeRepassword();
          }
        }
      }
    },
    async rejectRider() {
      this.rider.users.user_status = 3;
      let sendata = { id: this.rider.users.id, data: this.rider };
      this.rejecting = true;
      await this.$store.dispatch(
        "fetchRiderListBack/updateRiderDetails",
        sendata
      );
      this.$router.go(-1);
      this.rejecting = false;
    },
    async updateData() {
      if (this.$refs.form.validate()) {
        if (this.isApprove == true) {
          this.rider.users.user_status = 1;
        }
        let obj1 = JSON.parse(JSON.stringify(this.rider));
        for (let val in obj1.user_info_im) {
          delete obj1.user_info_im[val];
        }
        if (this.rider_book_bank_img) {
          obj1.user_info_im.ri_book_bank_img = this.rider_book_bank_img;
        }
        if (this.rider_phorabo_img) {
          obj1.user_info_im.ri_phorabo_img = this.rider_phorabo_img;
        }
        if (this.rider_registerbook_img) {
          obj1.user_info_im.ri_registerbook_img = this.rider_registerbook_img;
        }
        if (this.rider_id_card_img) {
          obj1.user_info_im.ri_id_card_img = this.rider_id_card_img;
        }
        if (this.rider_driving_lc_img) {
          obj1.user_info_im.ri_driving_license_front_img =
            this.rider_driving_lc_img;
        }
        if (this.rider_vehicle_number_img) {
          obj1.user_info_im.ri_plate_number_img = this.rider_vehicle_number_img;
        }
        if (this.rider_vehicle_img) {
          obj1.user_info_im.ri_plate_number_img = this.rider_vehicle_img;
        }
        if (this.rider_profile_img) {
          obj1.user_info_im.ri_profile_img = this.rider_profile_img;
        }
        let sendata = { id: this.rider.users.id, data: obj1 };
        obj1.user_info_im.ri_district_id = JSON.stringify(
          this.rider.user_info_im.ri_district_id
        );
        this.updating = true;
        await this.$store.dispatch(
          "fetchRiderListBack/updateRiderDetails",
          sendata
        );
        this.$router.go(-1);
        this.updating = false;
      }
    },
  },
};
</script>
